import "./dom";
import "./menu";

import "../scss/main.scss";
